module.exports = __webpack_public_path__ + "images/single-choice.webp";